import { useEffect } from "react";
import { Outlet } from "react-router-dom";

const ExternalAccessLayout = () => {
  useEffect(() => {
    document.body.classList.remove("page-loading");
  }, []);

  return <Outlet />;
};

export default ExternalAccessLayout;
